export default function isEnv(envs = []) {
  const { REACT_APP_ENV = "" } = process.env;
  return envs.includes(REACT_APP_ENV);
}
